<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Incongruencias - Documentos repetidos</h2>
    <div class="table-responsive">
      <table id="tablaIncongruencias" class="table table-striped table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Documento</th>
            <th>Nombre y Apellido</th>
            <th>CUIL</th>
            <th>CUIL Titular</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
        </tbody>
      </table>
    </div>
  </div>
</div>